import councilLogo from '@/assets/council-logo.png';
import { cn } from '@/lib/utils';

interface CouncilLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  /** Styles the image itself, for sizes the `size` presets do not cover. */
  iconClassName?: string;
  /** Pass "" for decorative use where the wordmark or nearby text already names it. */
  alt?: string;
}

const sizeMap = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12',
};

const textSizeMap = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-xl',
  xl: 'text-2xl',
};

const CouncilLogo = ({ size = 'md', showText = true, className, iconClassName, alt }: CouncilLogoProps) => {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={councilLogo}
        // ?? not ||, so an explicit alt="" stays empty and the image is
        // correctly announced as decorative.
        alt={alt ?? 'Council Logo'}
        className={cn(sizeMap[size], 'object-contain', iconClassName)}
      />
      {showText && (
        <span className={cn('font-bold', textSizeMap[size])}>Council</span>
      )}
    </div>
  );
};

export default CouncilLogo;
export { CouncilLogo };
